import React, { useEffect, useState } from "react";
import { Navbar, Nav, Container, NavItem} from 'react-bootstrap';
import { ImageElement } from "../../../components";
import { Link, useLocation } from 'react-router-dom';

function MainHeader() {
  const [NoAuth, setNoAuth] = useState(false);
  const [authPage, setAuthPage] = useState(true);
  const [scroll, setScroll] = useState(0);

  const location = useLocation();
  const { pathname } = location;
  let path = pathname.replace("/", "");

  useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY > 50
      if (scrollCheck !== scroll) {
        setScroll(scrollCheck)
      }
    })
  })
  useEffect(() =>{
    if(["home"].includes(path)){
      setNoAuth(true)
    }else{
      setNoAuth(false)
    }
    if(["login" , "signup", "reset-password", "forgot-password"].includes(path)){
      setAuthPage(false)
    }else{
      setAuthPage(true)
    }
    if(["home"].includes(path)){
      // setHome(true)
      document.querySelector("body").style.paddingTop = `0px`;
    }else{
      // setHome(false);
      setTimeout(() => {
        let navbar = document.querySelector(".header").clientHeight;
        document.querySelector("body").style.paddingTop = `${navbar}px`;
      }, 300);
    }
  })
  return (
    <header className={`header position-fixed w-100 ${scroll ? 'scroll' : ''}`}>
      <Container>
        <Navbar expand="lg" className="p-0">         
          <Navbar.Brand href="/home" className="p-0 me-0">
            <ImageElement source="logo.svg" alt="logo" />
          </Navbar.Brand>            
         {authPage &&  <><Navbar.Collapse id="navbarScroll">
            <Nav as="ul" className="mx-auto">
              {/* <NavItem as="li">
                <Link to="/home" className="p-0 nav-link">Home</Link>
              </NavItem> */}
              <NavItem as="li">
                <Link to="/aboutus" className="p-0 nav-link">About Us</Link>
              </NavItem>
              <NavItem as="li">
                <Link to="/howitworks" className="p-0 nav-link">How It Works</Link>
              </NavItem>
              <NavItem as="li">
                <Link to="/faqs" className="p-0 nav-link">FAQ</Link>
              </NavItem>
              <NavItem as="li">
                <Link to="/contact-us" className="p-0 nav-link">Contact Us</Link>
              </NavItem>
            </Nav>
          </Navbar.Collapse>             
          <div className="d-flex actionBtn align-items-center">
            {/* <Link to="/login" className="btn btn-outline-primary me-2">Login</Link> */}
            <Link to="/signup" className="btn btn-primary">Book Online</Link>
          </div>
          <Navbar.Toggle as="a" className="border-0 p-0" aria-controls="navbarScroll">
            <span className="navbar-toggler-icon"></span>
            <span className="navbar-toggler-icon"></span>
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          </>  
}
        </Navbar>
      </Container>
    </header>
  );
}


export default MainHeader;

